const BaseComponent = require('common/home/view');
const Server = require('helper/server');

class Home extends BaseComponent {
  constructor() {
    super();
    this.init();
    this.numPerScreen = 5; // 每屏图片张数
    this.$memberPhotosWrap = this.$el.find('.memberPhotos');
  }

  init() {
    this.initElegantBanner();
  }
  initElegantBanner() {

    let timer = null;
    if (timer) {
      clearInterval(timer);
    }
    Server.querySpecialColumn({ siteId: 77 }).then((data) => {
      let html = '';
      $.map(data, item => {
        const { cover, title, id, columnPath } = item;
        const img = cover ? `<img alt="${title}" src="${cover}" />` : `<p  class="noData">暂无图片</p>`;
        html += `<li class="img_${id}">
             <a href="${columnPath}">
                <div class="img-wrap">
                  ${img}
                </div>
                <p>
                  ${title}
                </p>
              </a>
            </li>`;
      });
      this.$memberPhotosWrap.append(html);
      if (data.length <= this.numPerScreen) {
        return false;
      }
      this.elegantBannerCount = 0;
      this.$memberPhotosWrap.width(data.length * 230 + 10);
      const thisObj = this;
      $('#memberPhoto-left').click(() => {
        thisObj.elegantBannerCount--;
        thisObj.elegantBannerMove(data.length);
      });
      $('#memberPhoto-right').click(() => {
        thisObj.elegantBannerCount++;
        thisObj.elegantBannerMove(data.length);
      });
    });
  }

  elegantBannerMove(size) {
    if (this.elegantBannerCount + this.numPerScreen > size ) {
      this.elegantBannerCount = size - this.numPerScreen;
    }
    if (this.elegantBannerCount < 0) {
      this.elegantBannerCount = 0;
    }
    this.$memberPhotosWrap.stop().animate(
      {
        left: -this.elegantBannerCount * 230
      },
      440
    );
  }
}

module.exports = Home;
